import * as React from 'react';
import * as styles from './styles.css';

export interface IStickyProps {
  rootClassName?: string;
  top: number;
  children: React.ReactNode;
}

export function Sticky({ rootClassName, children, top }: IStickyProps) {
  return (
    <div className={rootClassName}>
      <div className={styles['sticky']} style={{ top }}>
        {children}
      </div>
    </div>
  );
}
